import React from 'react';
import { ChecklistCell } from './ChecklistCell';
import type { ChecklistFooter, ChecklistOption } from '../checklist';

export type SelectCellProps = {
  options: readonly ChecklistOption[];
  /** The picked value, or null for none. */
  value: string | null;
  onChange: (value: string) => void;
  /** Shown when nothing is picked. */
  placeholder?: string;
  ariaLabel: string;
  disabled?: boolean;
  /** Shown in the cell instead of the picked label. */
  text?: string;
  /** A last row in the list that closes it and runs an action. */
  footer?: ChecklistFooter;
};

/** A cell holding one value, picked from a list that closes on the pick. */
export const SelectCell: React.FC<SelectCellProps> = ({
  value,
  onChange,
  ...props
}) => (
  <ChecklistCell
    {...props}
    single
    value={value === null ? [] : [value]}
    onChange={([picked]) => onChange(picked)}
  />
);
